<template>
  <account-modal class="set-account-for-fee-modal">
    <template slot="heading">
      <div>Set account {{ account.accountId }}<template v-if="account.hasName">&nbsp;“{{ account.name }}”</template> free from recurring fees?</div>
    </template>

    <template slot="content">
      <error-alert :error="error" />
    </template>

    <template slot="actions">
      <v-btn
        color="light-blue darken-3"
        flat
        :disabled="loading"
        @click="onSetButtonClick"
      >use</v-btn>

      <v-btn
        color="light-blue darken-3"
        flat
        @click="onCancelButtonClick"
      >cancel</v-btn>
    </template>
  </account-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_ACCOUNT_UPDATE } from '@/events/accounts'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import AccountApi from '@/services/Api/AccountApi'

  // Component
  import AccountModal from '@/components/accounts/AccountModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'SetRecurringFeeFreeModal',
    components: {
      AccountModal,
      ErrorAlert
    },
    data () {
      return {
        freeRecurringFeeSetApiRequest: new ApiRequest(AccountApi.setRecurringFeeFree)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      profileId () {
        return this.modal.data.userId
      },
      account () {
        return this.modal.data.account
      },
      loading () {
        return this.freeRecurringFeeSetApiRequest.loading
      },
      error () {
        return this.freeRecurringFeeSetApiRequest.error
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onSetButtonClick () {
        this.freeRecurringFeeSetApiRequest
          .execute(this.account.accountId)
          .then(this.freeRecurringFeeSetSuccessHandler)
          .catch(() => {})
      },
      onCancelButtonClick () {
        this.closeModal()
      },
      freeRecurringFeeSetSuccessHandler () {
        this.$eventHub.$emit(EVENT_ACCOUNT_UPDATE, this.profileId)
        this.closeModal()

        setTimeout(() => {
          this.showModal({
            name: 'SuccessFlashModal',
            data: { message: 'Account has been successfully set as free from recurring fees.' }
          })
        }, 100)
      }
    }
  }
</script>
